<template>
  <!-- title start -->
  <div class="in_abtCnt">
    <div class="in_abtCtop">
      <span :style="colors">
        <i class="xian1" :style="xiancolor"></i>
        {{ titletxt }}
        <i class="xian2" :style="xiancolor"></i>
      </span>
    </div>
  </div>
  <!-- title end -->
</template>

<script>
export default {
  name: "InTitle",
  components: {},
  computed: {},
  data() {
    return {
      lange: "ch",
    };
  },
  created() {},
  props: ["titletxt", "colors", "zong", "xiancolor"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.in_abtCnt {
  width: 62.5%;
  min-height: 35px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.in_abtCtop {
  width: 100%;
  display: block;
  text-align: center;
  position: relative;
  font-size: 40px;
  color: #02182c;
  /* font-weight: bold; */
  font-family: shsm, shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.in_abtCtop > span > i {
  width: 120%;
  height: 3px;
  display: block;
  position: absolute;
  top: 28px;
}
.in_abtCtop > span {
  position: relative;
  display: inline-block;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.in_abtCtop > span > i:nth-child(1) {
  left: -180%;
}
.in_abtCtop > span > i:nth-child(2) {
  right: -180%;
}
@media only screen and (max-width: 425px) {
  .in_abtCtop > span > i:nth-child(1) {
  left: -130%;
}
.in_abtCtop > span > i:nth-child(2) {
  right: -130%;
}
  .in_abtCtop {
    font-size: 18px;
  }
  .in_abtCtop > span > i {
    width: 80px;
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/component/InTitle.vue